<template>
  <div :key="blob.giftcard.id" class="absolute-fill elevation-8 gc-border" v-bind:class="{ black: !placeholder }">
    <div v-if="placeholder" class="absolute-fill grey gc-border loading-shimmer" />

    <!-- Note that you had been scaling the button here, but that's not really necessary since the size of the gift cards themselves is fairly constrained and avoids inconsistencies: v-bind:style="{ transform: `scale(${1 / scale})` }" -->
    <v-btn
      v-blur
      class="mt-n5 ml-n5"
      style="transition: unset;"
      v-bind:style="{
        'cursor': mode == 'preview' ? null : 'pointer',
        // 'pointer-events': mode == 'preview' ? null : 'auto',
        'transform': `rotate(${-blob.r}deg)`
      }"
      absolute rounded dark
      :color="blob.giftcard.claim_id ? 'grey lighten-1' : 'green lighten-2'"
      Xv-on="(mode == 'preview') || !showValue ? {} : { click: () => $emit('click') }"
      @click="$emit('click')"
    >
      <currency :code="blob.giftcard.cur" />{{showValue ? blob.giftcard.amt : ''}}
    </v-btn>

    <div
      v-if="[ 'purchase', 'edit' ].includes(mode) && !blob.giftcard.claim_id && showValue && !isVerifiedRecipient"
      class="absolute d-flex justify-center"
      style="width: 100%; bottom: -20px; Xpointer-events: auto;"
      v-bind:style="{ transform: `rotate(${-blob.r}deg)` }"
    >
      <v-btn
        v-blur
        rounded elevation="6" color="primary"
        @click="$emit('click')"
      >
        {{(mode == 'purchase') || (blob.sample && isOwner) ? 'Change merchant / amount…' : 'Add to gift card…'}}
      </v-btn>
    </div>

    <!-- The gift-of-choice gift card uses a special animation -->
    <video
      v-if="blob.giftcard.product_img == 'https://cdn.ellacard.com/giftcards_gift_of_choice.jpg'"
      class="user-select-none gc-border"
      playsinline autoplay muted loop draggable="false" width="100%"
      poster="//cdn.ellacard.com/media/e2ef27c8-b84f-4026-9db7-65af3168ae22/md.webp"
      src="//cdn.ellacard.com/media/e2ef27c8-b84f-4026-9db7-65af3168ae22/md.mp4"
      @loadedmetadata="onLoad"
      @error="onLoad"
    />
    <img
      v-else
      class="user-select-none gc-border"
      draggable="false"
      :src="blob.giftcard.product_img"
      @load="onLoad"
    />

  </div>
</template>

<style scoped>
img {
  pointer-events: none;
  width: 100%;
  height: 100%;
}
</style>

<script>
import Currency from '@/components/Currency.vue';

export default {
  name: 'giftcard-blob',

  components: { Currency },

  props: [ 'blob', 'skin', 'isOwner', 'isCardOwner', 'isVerifiedRecipient', 'scale', 'mode', 'action' ],

  data() {
    return {
      placeholder: true
    };
  },

  computed: {
    showValue() {
      return this.isOwner || this.isCardOwner || this.isVerifiedRecipient || !this.skin?.hide_giftcard_totals;
    }
  },

  methods: {
    onLoad() {
      this.placeholder = false;
      this.$emit('loaded');
    }
  }
}
</script>
